import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Text, Button, Skeleton, useToast } from '@chakra-ui/react';
import { CheckCircleOutline } from '@mui/icons-material';

import AdminLayout from '../components/admin/AdminLayout';
import { getAllReports, deleteReport } from '../services/ReportServices';
import { getUserById } from '../services/UserServices';
import { shortId, formatDateTime } from '../utils/format';

// Problems customers reported on their orders
const ReportsforAdmin = () => {

  const toast = useToast();
  const navigate = useNavigate();
  const [reports, setReports] = useState(null);
  const [users, setUsers] = useState({});

  useEffect(() => {
    getAllReports()
      .then(result => {
        const list = [...(result.reports || [])].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setReports(list);
        [...new Set(list.map(r => r.userId))].forEach(id =>
          getUserById(id).then(u => setUsers(prev => ({ ...prev, [id]: u.user }))).catch(() => {}));
      })
      .catch(() => setReports([]));
  }, []);

  const resolve = async (report) => {
    try {
      await deleteReport(report._id);
      setReports(prev => prev.filter(r => r._id !== report._id));
      toast({ title: 'Marked as resolved', status: 'success', duration: 1500, position: 'top' });
    } catch (e) {
      toast({ title: 'Could not update', status: 'error', duration: 2500 });
    }
  };

  return (
    <AdminLayout title='Reports' subtitle={reports ? `${reports.length} open` : 'Loading…'} >
      {reports === null
        ? Array(2).fill(null).map((_, i) => <Skeleton key={i} height='120px' borderRadius='12px' mb={3} />)
        : reports.length === 0
          ? <Box textAlign='center' py={12} bg='raano.white' borderRadius='12px' border='1px solid' borderColor='raano.border' >
            <CheckCircleOutline sx={{ fontSize: 48, color: '#2f9e44' }} />
            <Text fontWeight={700} mt={2} >All problems solved</Text>
            <Text fontSize={14} color='blackAlpha.600' mt={1} >Issues customers report on their orders will appear here.</Text>
          </Box>
          : reports.map(report => {
            const user = users[report.userId];
            return (
              <Box key={report._id} bg='raano.white' borderRadius='12px' border='1px solid' borderColor='raano.border' p={4} mb={3} >
                <Box display='flex' justifyContent='space-between' gap={2} >
                  <Box minWidth={0} >
                    <Text fontWeight={700} noOfLines={1} >{user ? `${user.firstName} ${user.lastName}` : 'Customer'}</Text>
                    <Text fontSize={12} color='blackAlpha.600' >Order {shortId(report.orderId)} · {formatDateTime(report.createdAt)}</Text>
                  </Box>
                </Box>
                <Text mt={3} fontSize={14} bg='raano.surface' p={3} borderRadius='8px' whiteSpace='pre-wrap' >{report.content}</Text>
                <Box display='flex' gap={2} mt={3} >
                  <Button size='sm' flex={1} variant='wipe' height='40px' px='18px' fontSize='14px' onClick={() => navigate('/admin/orders', { state: { status: 'all', focus: report.orderId } })} >View order</Button>
                  <Button flex={1} variant='ink' height='40px' fontSize='14px' onClick={() => resolve(report)} >Mark resolved</Button>
                </Box>
              </Box>
            );
          })}
    </AdminLayout>
  )
}

export default ReportsforAdmin;
